/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Ready_HintInputs */

const en_loading_ready_hint = /** @type {(inputs: Loading_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your content will appear here as soon as it is ready.`)
};

const id_loading_ready_hint = /** @type {(inputs: Loading_Ready_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten akan tampil di sini begitu siap.`)
};

/**
* | output |
* | --- |
* | "Your content will appear here as soon as it is ready." |
*
* @param {Loading_Ready_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const loading_ready_hint = /** @type {((inputs?: Loading_Ready_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Ready_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_loading_ready_hint(inputs)
	return en_loading_ready_hint(inputs)
});